import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListStore({
    loading,
    filteredStores,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Store Name</th>
                        <th>Store Code</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredStores.length > 0 ? (
                        filteredStores.map((store) => {
                            const isActive = store.status === "Active";
                            return (
                                <tr key={store.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="storeSelect"
                                            disabled={store.status === "Inactive"}
                                            checked={selected === store.id}
                                            onChange={() => handleSelect(store.id)}
                                        />
                                    </td>

                                    <td>{store.storeName}</td>
                                    <td>{store.storeCode}</td>

                                    <td>
                                        <button
                                            type="button"
                                            className={`badge border-0 ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(store)}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center text-muted">
                                No stores found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
